<template>
  <div
    style="
      background: rgba(249, 249, 249, 1);
      padding: 1.2rem 0.2rem 0.6rem 0.2rem;
    "
  >
    <div class="contact-mobile">
      <p class="title">{{ $t('ContactUs.des') }}</p>
      <p class="content" style="margin-top: 0.2rem">
        {{ $t('ContactUs.title1') }}
      </p>
      <p class="content" style="color: rgb(211, 36, 23)">
        {{ $t('ContactUs.email1') }}
      </p>
      <!-- <p class="content" style="color:rgb(211, 36, 23)">{{$t('ContactUs.tel1')}}</p> -->
      <p class="content">{{ $t('ContactUs.hour1') }}</p>

      <p class="content" style="margin-top: 0.2rem">
        {{ $t('ContactUs.title2') }}
      </p>
      <p class="content" style="color: rgb(211, 36, 23)">
        {{ $t('ContactUs.email2') }}
      </p>
      <!-- <p class="content" style="color: rgb(211, 36, 23)">
        {{ $t('ContactUs.tel2') }}
      </p>
      <p class="content">{{ $t('ContactUs.hour2') }}</p> -->

      <p class="content" style="margin-top: 0.2rem">
        {{ $t('ContactUs.introduce') }}
      </p>

      <p class="content text-bold" style="margin-top: 0.2rem">
        {{ $t('ContactUs.phone') }}
      </p>
      <ul class="content contact-list">
        <li class="tel-item">
          <span class="tel-country">{{ $t('ContactUs.singapore') }} </span>
          <span class="tel-text">+65 6631 8453</span>
        </li>
        <!-- <li class="tel-item bottom1">
          <span class="tel-country"></span>
          <span class="tel-text">+65 6631 7935</span>
        </li> -->
        <li class="tel-item bottom1">
          <span class="tel-country">{{ $t('ContactUs.china') }}</span>
          <span class="tel-text">+86 755 2692 6753</span>
        </li>
      </ul>

      <p class="content text-bold" style="margin-top: 0.2rem">WhatsApp:</p>
      <ul class="content contact-list">
        <li class="tel-item">
          <span class="tel-country">{{ $t('ContactUs.singapore') }} </span>
          <span class="tel-text">+65 6631 8453</span>
        </li>
        <!-- <li class="tel-item bottom1">
          <span class="tel-country"></span>
          <span class="tel-text">+65 6631 7935</span>
        </li> -->
      </ul>

      <p class="content text-bold" style="margin-top: 0.2rem">{{ $t('ContactUs.fax') }}</p>
      <ul class="content contact-list">
        <li class="tel-item">
          <span class="tel-country">{{ $t('ContactUs.singapore') }} </span>
          <span class="tel-text">+65 6631 9508</span>
        </li>
      </ul>

      <p class="content text-bold" style="margin-top: 0.2rem">
        {{ $t('ContactUs.title3') }}
      </p>
      <p class="content" v-html="$t('ContactUs.address')"></p>
      <Row style="margin-top: 0.45rem; text-align: left">
        <Col class="nav-find">
          <p class="content">{{ $t('enquiryBox.left.title3') }}:</p>
          <Poptip trigger="hover" placement="top-start">
            <img
              src="../assets/web/微信.svg"
              style="margin-left: -0.1rem; width: 0.68rem"
            />
            <div slot="content">
              <img
                src="../assets/web/红茶移动微信二维码.jpg"
                style="width: 150px"
              />
            </div>
          </Poptip>
          <a href="https://www.facebook.com/redteamobile" target="_Blank">
            <img
              src="../assets/web/Facebook.svg"
              style="margin-left: -0.08rem"
            />
          </a>
          <a href="https://twitter.com/redteamobile" target="_Blank">
            <img src="../assets/web/Twitter.svg" />
          </a>
          <a href="https://www.linkedin.com/company/13216053/" target="_Blank">
            <img src="../assets/web/Linkedin.svg" />
          </a>
          <a
            href="https://www.zhihu.com/org/redteamobile/activities"
            target="_Blank"
          >
            <img src="../assets/web/知乎.svg" />
          </a>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact-mobile',
  components: {}
}
</script>
<style lang="less" scoped>
.contact-mobile {
  .title {
    color: rgba(32, 49, 82, 1);
    font-family: 'Poppins-Regular';
    font-size: 0.16rem;
    text-align: left;
  }
  .content {
    color: rgba(32, 49, 82, 1);
    // font-family: 'Poppins-ExtraLight';
    font-size: 0.12rem;
    text-align: left;
  }
  .contact-list {
    list-style: none;
    flex-direction: column;
    margin-top: 0;

    .tel-item {
      // padding-left: 0.5rem;
      // margin-bottom: 0.1rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .tel-country {
        width: 80px;
      }
      .tel-text {
        flex: 1;
      }

      &.bottom1 {
        margin-bottom: 0.1rem;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .text-bold {
    font-weight: bold;
  }

  .text-14px {
    font-size: 14px;
    // padding-left: 0.5rem;
  }

  .mt-20px {
    margin-top: 0.05rem;
  }
}
</style>
